import React, { useEffect } from "react";
import { Form, Input, Button } from "antd";
import AppModal from "../../modals/AppModal";

type Props = {
  open: boolean;
  loading?: boolean;
  onCancel: () => void;

  // use exactly one of these depending on mode
  onAdd?: (values: { title: string }) => void;
  onEdit?: (values: { title: string }) => void;

  mode?: "add" | "edit";
  initialTitle?: string;
  className?: string;
};

const AddDescriptorSetModal: React.FC<Props> = ({
  open,
  loading,
  onCancel,
  onAdd,
  onEdit,
  mode = "add",
  initialTitle,
  className,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.setFieldsValue({ title: initialTitle ?? "" });
    }
  }, [open, initialTitle, form]);

  const handleSubmit = async () => {
    const values = await form.validateFields();
    if (mode === "edit" && onEdit) onEdit(values);
    else if (onAdd) onAdd(values);
  };

  const modalTitle =
    mode === "edit" ? "Edit descriptor set" : "Add new descriptor set";
  const primaryBtnText = mode === "edit" ? "Save" : "Add";

  return (
    <AppModal
      open={open}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      title={modalTitle}
      width={600}
      footer={
        <div style={{ display: "flex", justifyContent: "center", gap: 12 }}>
          <Button onClick={onCancel} className="cancel-button">
            Cancel
          </Button>
          <Button
            loading={loading}
            onClick={handleSubmit}
            className="add-button"
          >
            {primaryBtnText}
          </Button>
        </div>
      }
      className={className}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: "Title is required" }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </AppModal>
  );
};

export default AddDescriptorSetModal;
